export enum HiProDecisionStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Waiting = 'WAITING',
}
